const yearWise = [
    {
      territory: "Territory 1",
      plan: 4,
      online: 4,
      physical: 4
    },
    {
      territory: "Territory 2",
      plan: 0,
      online: 0,
      physical: 0
    },
    {
      territory: "Territory 3",
      plan: 2,
      online: 2,
      physical: 2
    },
    {
      territory: "INHOUSE",
      plan: 0,
      online: 0,
      physical: 0
    },
    {
      territory: "TOTAL DAYS",
      plan: 6,
      online: 6,
      physical: 6
    },
  ];

const other = [
    {
      territory: "Territory 1",
      plan: 4,
      actuals: 4
    },
    {
      territory: "Territory 1",
      plan: 0,
      actuals: 0
    },
    {
      territory: "Territory 1",
      plan: 2,
      actuals: 2
    },
    {
      territory: "INHOUSE",
      plan: 0,
      actuals: 0
    },
    {
      territory: "TOTAL DAYS",
      plan: 6,
      actuals: 6
    },
  ];

export {yearWise, other}
  